export default [
	{
		text: '#',
		value: 'id',
	},
	{
		text: 'rut',
		value: 'pch_provider_rut',
		format: 'rut',
	},
	{
		text: 'proveedor',
		value: 'pch_provider_business_name',
	},
	{
		text: 'responsable',
		value: 'g_user_hr_employee_name_case',
	},
	{
		text: 'fecha pago',
		value: 'date_payment',
		format: 'date',
		align: 'right',
	},
	{
		text: 'pagado',
		value: 'amount_paid',
		format: 'currency',
		align: 'right',
	},
	{
		text: 'creacion',
		value: 'created_at',
		format: 'date',
		align: 'right',
	},
]